import { Company } from 'generated/apolloComponents'
import useTranslation from 'next-translate/useTranslation'
import styles from '../Company.module.scss'
import { LocationMark } from '@/components/atoms'
import { arrayOfObjectToStringArrayByKey } from '@/helpers/utils'

type Props = {
  company: Company
}

const BlankLayout = ({ company }: Props) => {
  const { t, lang } = useTranslation('common')

  return (
    <div className='container'>
      <div
        className={`bg-white rounded-xl flex flex-col sm:flex-row items-center justify-between ${styles.company__blank__wrapper}`}
      >
        <div>
          <h3 className='text-18 font-medium'>{company.name}</h3>
          <div className='flex mt-3'>
            {company.locations.length > 0 && (
              <div className='ml-14'>
                <LocationMark
                  companyAmount={arrayOfObjectToStringArrayByKey(
                    company.locations,
                    lang === 'pl' ? 'cityPl' : 'cityEn'
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <a
          href={`/companies/profiles/${company.id}/claim`}
          className='text-primary'
        >
          {t('claim_profile')}
        </a>
      </div>
    </div>
  )
}

export default BlankLayout
